import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { db } from "../services/firebase";
import { collection, addDoc, setDoc, doc, serverTimestamp } from "firebase/firestore";
import { nanoid } from "nanoid";

export default function RequestCode() {
  const [searchParams] = useSearchParams();
  const unlockKey = searchParams.get("key");
  const isUnlocked = unlockKey === "teamscan2025";

  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!isUnlocked) {
    return <p style={{ textAlign: "center", marginTop: "2rem" }}>🔒 Access denied</p>;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email || !email.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }

    const generatedCode = nanoid(16);
    const fullLink = `https://teamscan.no-nonsense.management/input/${generatedCode}`;

    try {
      await setDoc(doc(db, "codes", generatedCode), {
        email,
        createdAt: serverTimestamp(),
      });

      const response = await fetch("/api/sendCodeEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, fullLink })
      });

      let result;
      try {
        result = await response.json();
      } catch (parseErr) {
        throw new Error("Malformed response from server");
      }

      if (!response.ok) {
        throw new Error(result?.error || "Failed to send email");
      }

      setSubmitted(true);
    } catch (err: any) {
      console.error("❌ Submission error:", err);
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "3rem auto", padding: "1rem" }}>
      <h2>Request a Team Code</h2>
      {submitted ? (
        <p>✅ Thanks! Your request has been received. You'll get an email shortly.</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <label>
            Your email address:
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%", padding: "0.5rem", marginTop: "0.5rem", marginBottom: "0.5rem" }}
              required
            />
            <p style={{ fontSize: "0.9rem", marginBottom: "1rem" }}>
              If you are worried about privacy, you can use an anonymous email address.<br />
              Nếu bạn lo lắng về quyền riêng tư, bạn có thể sử dụng địa chỉ email ẩn danh.
            </p>
          </label>
          {error && <p style={{ color: "red", marginBottom: "1rem" }}>{error}</p>}
          <button
            type="submit"
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "#0070f3",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Request Code
          </button>
        </form>
      )}
    </div>
  );
}
